<groundworks-card (click)="toggleCollapse()" (keydown.enter)="toggleCollapse()" (keydown.space)="toggleCollapse()"
  [isCollapsible]="true" [title]="quote().name ?? ''" [cardClasses]="initiallyExpanded() ? [] : ['mt-4']"
  [initialCollapsed]="!initiallyExpanded()">
  <groundworks-card-body>
    <div class="row g-3 mb-3">
      <div class="col-12">
        <groundworks-card [cardClasses]="['shadow-none']">
          <groundworks-card-body>
            <h2 class="h5 mb-4">Products</h2>
            <div class="table-responsive">
              <groundworks-table [data]="tableData()" />
            </div>
          </groundworks-card-body>
        </groundworks-card>
      </div>
    </div>
    @if (quote().financing) {
    <div class="row mt-3">
      <div class="col-12">
        <app-financing-summary [financing]="quote().financing!" [soldTotal]="quote().soldTotal" />
      </div>
    </div>
    }
  </groundworks-card-body>
</groundworks-card>
